import React, { memo } from 'react';
import { StyleSheet, View } from 'react-native';
import { rem } from 'design-system/values';
import { IconBank } from 'design-system/icons/IconBank';
import IconMerchant from 'design-system/icons/IconMerchant';
import useColors from 'hooks/useColors';
import useStyles from 'hooks/useStyles';
import createStyleSheets from 'utils/createStyleSheets';
const SIZE = rem(44);
const BADGE_SIZE = rem(18);
const HiddenSubscriptionLogo = () => {
    const colors = useColors();
    const styles = useStyles(styleSet);
    return (<View style={staticStyles.container} testID="hidden-subscription-logo">
      <View style={[styles.placeholder, staticStyles.logo]}>
        <IconMerchant width={rem(24)} height={rem(24)} color={colors.elements.brand}/>
      </View>
      <View style={[styles.placeholder, styles.badge]}>
        <IconBank width={rem(10)} height={rem(10)} color={colors.elements.brand}/>
      </View>
    </View>);
};
const staticStyles = StyleSheet.create({
    container: {
        width: SIZE,
        height: SIZE,
    },
    logo: {
        width: SIZE,
        height: SIZE,
        borderRadius: SIZE,
    },
});
const styleSet = createStyleSheets((colors) => ({
    placeholder: {
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: colors.background.brandLight,
    },
    badge: {
        position: 'absolute',
        right: 0,
        bottom: 0,
        width: BADGE_SIZE,
        height: BADGE_SIZE,
        borderRadius: BADGE_SIZE,
        borderWidth: StyleSheet.hairlineWidth,
        borderColor: colors.borders.divider,
    },
}));
export default memo(HiddenSubscriptionLogo);
